/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import dayjs from "utils/dayjs";
import queryString from 'query-string';

import { Box, Button, FormControl, Tooltip } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';

import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput } from 'data/data';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import PageInfo from 'components/PageInfo';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { getMgmtDiagnosisResultsByQuery } from 'components/axios/mgmtDiagnosisResultAxios';
import { fromServerFormat } from 'components/date_picker/dateUtils';
import useConfig from 'hooks/useConfig';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const DiagnosisResultSetting = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
    const { t, i18n } = useTranslation();
    const { mode } = useConfig();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [equipments, setEquipments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    const [toggleStr, setToggleStr] = useState(true);
  
    const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
    // const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
  
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    // const excelTitle = t('menu.monitoring.equipment');
    // const excelTopHeaders = [t('message.common.subtitle.status'), t('message.common.subtitle.recent.diagnosis'), t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'),
    //    t('message.common.subtitle.company.name'), t('message.common.subtitle.equipment.level1'), t('message.common.subtitle.equipment.level2'), t('message.common.subtitle.equipment.level3'), 
    //    t('message.common.subtitle.equipment.name'), t('message.common.subtitle.equipment.number'), t('message.common.subtitle.position'), t('message.common.subtitle.defect')];
    // const fileName = excelTitle+"_"+Date.now();
    // const [excelDatas, setExcelDatas] = useState([]);
  
    // const connectProblemDay = dayjs.utc(new Date()).tz(process.env.REACT_APP_TIMEZONE).subtract(7, "d").format("YYYY-MM-DD");
  
    const searchFields = [{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}
      , {code:"companyName", title:t('message.common.subtitle.company.name')}
    ];
  
    let qs = queryString.parse(window.location.search);
    // let falutStatusSelectColor = "";
    
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
  
    // if (equipmentFaultStatus === '' || equipmentFaultStatus === "sum") {
    //   falutStatusSelectColor = " selected";
    // }
    
    let columns = [];
    columns = [
      { field: 'equipment.opStatus', headerName: t('message.common.subtitle.status'), sortable:true, width: 80,
        cellClassName : 'statusButton'
        , renderCell:(params)=>(
          <div style={{textAlign:"center"}} className={params.row?.equipment?.opStatus === 'O' ? 'condition6' : params.row?.equipment?.opStatus === 'S' ? 'condition1' : ''}>
            <Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentOpStatus", params.row?.equipment?.opStatus)?.[0]?.title}</Link>
          </div>)
      },
      { field: 'analysisAt', headerName: t('message.common.subtitle.diagnosis.datetime'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{fromServerFormat(params.row?.analysisAt, {format:t('message.common.text.date.format.datetimess')})}</Link>)
      },
      { field: 'equipment.managementCompany.info.name', headerName: t('message.common.subtitle.company.name'), sortable:true, width: 120
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>
          <Tooltip title={<div style={{color:'#000'}}>{params.row?.equipment?.managementCompany?.info?.address}</div>}><span>{params.row?.equipment?.managementCompany?.info?.name}</span></Tooltip>
          </Link>)
      },
      { field: 'equipment.equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.parent?.name}</Link>)
      },
      { field: 'equipment.equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.name}</Link>)
      },
      { field: 'equipment.equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.name}</Link>)
      },
      { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
      },
      { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
      },
      { field: 'equipment.location', headerName: t('message.common.subtitle.position'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.equipment?.location}</Link>)
      },
      { field: 'diagnosisSensor', headerName: t('message.common.subtitle.diagnosis.sensor'), sortable:false, width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>
          {( (params.row?.vibrationCollectionNumerator ?? 0) + (params.row?.noiseCollectionNumerator ?? 0) )} / {( (params.row?.vibrationCollectionDenominator ?? 0) + (params.row?.noiseCollectionDenominator ?? 0) )}
        </Link>)
      },
      { field: 'lowestDiagnosisRank', headerName: t('message.common.subtitle.diagnosis.result'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/setting/iot/diagnosis-result/'+params.row?.id+searchParamString}>{params.row?.lowestDiagnosisRank}</Link>)
      },
    ];

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "analysisAt,DESC"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchOpStatus) setEquipmentOpStatus(qs.searchOpStatus);
        // if (qs.searchStatus) setEquipmentFaultStatus(qs.searchStatus);
        if (qs.searchSubway) setSubwayCode(qs.searchSubway);
        if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
        if (qs.searchStation) setStationId(qs.searchStation);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchOpStatus) {searchParamCopy.searchOpStatus = qs.searchOpStatus};
        // if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchWorkingPart) {searchParamCopy.searchWorkingPart = qs.searchWorkingPart};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchOpStatus/*, qs.searchStatus*/
      , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

      // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
        });
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        });
      }
    },[equipmentCategoryLevel2Id]);
  
    // 목록
    useEffect(()=> {
      if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam) {
        equipmentList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [currentPage, isLoading, pageSize, equipmentFaultStatus, getEnumValueByEnumName("EquipmentFaultStatus"), isParam, sortModel]);
    }, [currentPage, isLoading, pageSize, isParam, sortModel]);

    // let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
    // let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
  
    const equipmentList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
      setCurrentPage(curPage)
  
      let param = {
        page : curPage,
        size : pageSize,
        iotInstlYn : true
      };
      if (equipmentOpStatus) {
        param["equipment.opStatus"] = equipmentOpStatus;
      }
      
      if (equipmentCategoryLevel1Id) {
        param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }
      if (equipmentCategoryLevel2Id) {
        param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }
      if (equipmentCategoryLevel3Id) {
        param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }
      // if (equipmentFaultStatus === 'problem') {
      //   param.latestCommYmd = 'lte('+connectProblemDay+')';
      // } else {
        // if (equipmentFaultStatus !== 'sum')
        //   param.status = equipmentFaultStatus;
        let keyword = searchKeyword;
        if (searchKeyword) {
            if (searchField && (searchField === 'name' || searchField === 'equipmentNo' || searchField === 'companyName')) {
              keyword = 'contains('+searchKeyword+')';
            }
  
            if (searchField === 'name') {
              param['equipment.name'] = keyword;
            } else if (searchField === 'equipmentNo') {
              param['equipment.equipmentNo'] = keyword;
            } else if (searchField === 'companyName') {
              param['equipment.managementCompany.info.name'] = keyword;
            }
        }
      // }
      if (sortModel && sortModel.length > 0)
        param.sort = sortModel[0].field+","+sortModel[0].sort;
      else
        param.sort = "analysisAt,DESC";
      Promise.all([
        getMgmtDiagnosisResultsByQuery(param).then((data)=>{
          if (data != null) {
            if(data.page) {
              setPageInfo(data.page);
            } else {
              setCurrentPage(0);
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
            }
            if(data._embedded) {
              let list = data._embedded.diagnosisResultReses;
              setEquipments(list);
              setIsLoading(true);
              return data.page.totalElements;
            } else {
              setEquipments([]);
            }
          } else {
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
            setEquipments([]);
          }
          setIsLoading(true);
          return 0;
        }),
      ]).then((res)=>{
        
      })
      setIsLoading(true);
    }
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
 
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      equipmentList(0);
      // setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (equipmentOpStatus) {searchParamCopy.searchOpStatus = equipmentOpStatus};
      // if (equipmentFaultStatus) {searchParamCopy.searchStatus = equipmentFaultStatus};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    // const handleMobileOnKeyPress = e => {
    //   if (e.key === 'Enter') {
    //     handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    //   }
    // };

    // const handleMobileSearch = (event) => {
    //   handleSearch(event);
    //   handleClose();
    // };
  
    // const statusTapSearch = (vCode) => {
    //   setCurrentPage(0);
    //   pageInfo.number = 0;
    //   setPageInfo(pageInfo);
    //   setEquipmentFaultStatus(vCode);
    //   initSearch();

    //   let searchParamCopy = {...searchParam};
    //   searchParamCopy.page = 0;
    //   if (pageSize) {searchParamCopy.size = pageSize};
    //   if (searchField) {searchParamCopy.searchField = searchField};
    //   searchParamCopy.searchStatus = vCode;
    //   searchParamCopy.searchKeyword = '';
    //   searchParamCopy.searchOpStatus = '';
    //   searchParamCopy.searchSubway = '';
    //   searchParamCopy.searchWorkingPart = '';
    //   searchParamCopy.searchStation = '';
    //   searchParamCopy.searchlevel1 = '';
    //   searchParamCopy.searchlevel2 = '';
    //   searchParamCopy.searchlevel3 = '';
    //   setSearchParam(searchParamCopy)
    //   const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    //   navigate("?"+paramString)
    // };
  
    const initSearch = ()  => {
      setEquipmentOpStatus('');
      setSubwayCode('');
      setWorkingPartId('');
      setStationId('');
      setEquipmentCategoryLevel1Id('');
      setEquipmentCategoryLevel2Id('');
      setEquipmentCategoryLevel3Id('');
      setToggleStr(!toggleStr);
      setSearchKeyword('');
      setCurrentPage(0);
      setIsLoading(false);
      // setExcelDatas([]);
    };

    const [open, setOpen] = useState(false);

    // const handleClickOpen = () => {
    //   setOpen(true);
    // };

    // const handleClose = (event, reason) => {
    //   if (reason !== 'backdropClick') {
    //     setOpen(false);
    //   }
    // };
  
    // if (isLoading) {
    return (
      <div className="sub_container" style={{padding:"15px 0"}}>
        <div className='search_section'>
          {/* <ul className='condition' style={{marginTop:"px"}}>
            <li className={`sum${falutStatusSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalEquipmentGroupCount}</li>
            {equipmentGroupCounts &&
              equipmentGroupCounts.map(function(item, i) {
                falutStatusSelectColor = "";
                if (item.id === equipmentFaultStatus) {
                  falutStatusSelectColor = " selected";
                }
                let addTitle = '';
                // if (item.id === 'O9_G')
                //   addTitle = 'ISO(A)';
                // else if (item.id === 'O7_N')
                //   addTitle = 'ISO(B)';
                // else if (item.id === 'O5_D')
                //   addTitle = 'ISO(C)';
                // else if (item.id === 'O1_F')
                //   addTitle = 'ISO(D)';
                return (
                  <li key={i} className={`${item.id}${falutStatusSelectColor}`} onClick={() => statusTapSearch(item.id)} style={{cursor:"pointer"}}>{addTitle == '' && item.title}{addTitle}: {item.count}</li>      
                )
              }) }
          </ul> */}
          
          <div className='selectbox'>
            <div className="desktop_serach">
              <Box component="form">
                <div>
                  <div>
                  {getEnumValueByEnumName("EquipmentOpStatus") && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomEnumSelect
                        key={equipmentOpStatus}
                        label={t('message.common.subtitle.opStatus')}
                        labelName={t('message.common.subtitle.opStatus')}
                        name={'equipmentOpStatus'}
                        defaultValue={equipmentOpStatus}
                        onChange={(e)=>{
                          setEquipmentOpStatus(e.target.value);
                        }}
                        list={getEnumValueByEnumName("EquipmentOpStatus")}
                    />
                    </FormControl>
                    }
                    {equipmentCategoryLevel1s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel1Id}
                        label={t('message.common.subtitle.equipment.level1')}
                        labelName={t('message.common.subtitle.equipment.level1')}
                        name={'level1'}
                        defaultValue={equipmentCategoryLevel1Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel1Id(e.target.value);
                          setEquipmentCategoryLevel2Id('');
                          setEquipmentCategoryLevel3Id('');
                        }}
                        list={equipmentCategoryLevel1s}
                    />
                    </FormControl>
                    }
                    {equipmentCategoryLevel2s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel2Id}
                        label={t('message.common.subtitle.equipment.level2')}
                        labelName={t('message.common.subtitle.equipment.level2')}
                        name={'level2'}
                        defaultValue={equipmentCategoryLevel2Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel2Id(e.target.value);
                          setEquipmentCategoryLevel3Id('');
                        }}
                        list={equipmentCategoryLevel2s}
                    />
                    </FormControl>
                    }
                    {equipmentCategoryLevel3s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel3Id}
                        label={t('message.common.subtitle.equipment.level3')}
                        labelName={t('message.common.subtitle.equipment.level3')}
                        name={'level3'}
                        defaultValue={equipmentCategoryLevel3Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel3Id(e.target.value);
                        }}
                        list={equipmentCategoryLevel3s}
                    />
                    </FormControl>
                    }
                    <div style={{display:"inline-block"}}>
                    {searchFields && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomEnumSelect
                        key={searchField}
                        label={t('message.common.btn.search')}
                        labelName={t('message.common.btn.search')}
                        name={'searchField'}
                        defaultValue={searchField}
                        onChange={(e)=>{
                          setSearchField(e.target.value);
                        }}
                        list={searchFields}
                    />
                    </FormControl>
                    }
                      <FormControl sx={{ m: 1 }} variant="standard">
                        <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword || ''} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                      </FormControl>
    
                      <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                        <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>

        <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
          <DataGridPro
            rows={equipments && equipments !== undefined ? equipments : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />

          <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
        </Box>
          
      </div>
    );
  {/* } */}
}

export default DiagnosisResultSetting;